module.exports = __webpack_public_path__ + "img/PS10.13e2a7dd.png";